import api from './api';

// Get topics by subject
export const getTopicsBySubject = async (subject) => {
  try {
    const response = await api.get(`/topics/${subject}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all subjects with topics
export const getSubjectsWithTopics = async () => {
  try {
    const response = await api.get('/topics/subjects');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Save exam topic details
export const saveExamTopicDetails = async (examId, subject, topicResults) => {
  try {
    const response = await api.post(`/topics/exams/${examId}/topics`, {
      subject,
      topicResults
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get exam topic details for a specific subject
export const getExamTopicDetails = async (examId, subject) => {
  try {
    const response = await api.get(`/topics/exams/${examId}/topics/${subject}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all exam topic details
export const getAllExamTopicDetails = async (examId) => {
  try {
    const response = await api.get(`/topics/exams/${examId}/topics`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete exam topic details
export const deleteExamTopicDetails = async (examId, subject) => {
  try {
    const response = await api.delete(`/topics/exams/${examId}/topics/${subject}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get topic performance analysis
export const getTopicPerformanceAnalysis = async (subject, limit = 10) => {
  try {
    const response = await api.get(`/topics/analysis/${subject}`, {
      params: { limit }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
